<template>
    <div class="unlimited_traffic card">
      <div class="response_table" >
        <div class="summary card" v-if="summary.length > 0">
          <p v-for="(sum, key) in summary" :key="key">
            <span>{{ translate("dashboard.unlimited.summary." + sum.name) }}:</span>
            <span v-html="sum.value" />
          </p>
        </div>

        <table>
          <colgroup>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
            <col>
          </colgroup>

          <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th colspan="9">Device</th>
              <th colspan="10" class="unlim">Unlimited</th>
              <th colspan="4">Packets</th>
            </tr>

            <tr>
              <th scope="col" colspan="1">
                {{ translate("dashboard.unlimited.device_status") }}
              </th>
              <th scope="col" colspan="1">
                {{ translate("dashboard.unlimited.device_blocked") }}
              </th>
              <th scope="col" colspan="3">
                {{ translate("dashboard.unlimited.device_info") }}
              </th>
              <th scope="col" colspan="3">
                {{ translate("dashboard.unlimited.device_location") }}
              </th>
              <th scope="col" colspan="1">
                {{ translate("dashboard.unlimited.marine_traffic") }}
              </th>

              <th scope="col" class="unlim" colspan="1">
                {{ translate("dashboard.unlimited.unlimited_slot") }}
              </th>
              <th scope="col" class="unlim" colspan="2">
                {{ translate("dashboard.unlimited.unlimited_mno") }}
              </th>
              <th scope="col" class="unlim" colspan="2">
                {{ translate("dashboard.unlimited.unlimited_iccid") }}
              </th>
              <th scope="col" class="unlim" colspan="3">
                {{ translate("dashboard.unlimited.unlimited_packet") }}
              </th>
              <th scope="col" class="unlim" colspan="2">
                {{ translate("dashboard.unlimited.unlimited_expiry") }}
              </th>

              <th scope="col" colspan="2">
                {{ translate("dashboard.unlimited.packet_tariff_name") }}
              </th>
              <th scope="col" colspan="2">
                {{ translate("dashboard.unlimited.traffic_rest") }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(traffic, key) in device_unlimited_traffic" :key="key" class="traffic_item">
              <td :data-label="translate('dashboard.unlimited.device_status')" colspan="1">
                <div class="status__wrap">
                  <span
                    v-if="traffic.device.status"
                    class="mdi mdi-access-point problem_device online" >
                  </span>
                  <span
                    v-if="!traffic.device.status"
                    class="mdi mdi-access-point-off problem_device offline" >
                  </span>
                </div>
              </td>
              <td :data-label="translate('dashboard.unlimited.device_blocked')" colspan="1">
                <div class="status__wrap">
                  <span
                      v-if="traffic.device.blocked"
                      class="mdi mdi-lock-alert problem_device blocked"
                  />
                </div>
              </td>
              <td :data-label="translate('dashboard.unlimited.device_info')" colspan="3">
                <router-link :to="'/device/' + traffic.device.fid">
                  {{ traffic.device.fid }}
                </router-link>
                <p>{{ traffic.device.name }}</p>
              </td>
              <td :data-label="translate('dashboard.unlimited.device_location')" colspan="3">
                {{ traffic.device.location }}
              </td>

              <td :data-label="translate('dashboard.unlimited.marine_traffic')" colspan="1">
                <a v-if="traffic.device.location_link" :href="traffic.device.location_link" >
                  <span class="mdi mdi-web"></span>
                </a>
              </td>

              <td :data-label="translate('dashboard.unlimited.unlimited_slot')" class="unlim" colspan="10">
                <p v-for="(unlim, key) in traffic.traffic.unlim" :key="key">
                  <span class="slot">{{ unlim.slot }}</span>
                  <span>{{ unlim.mno }}</span>
                  <span>{{ unlim.iccid }}</span>
                  <span class="packet">{{ unlim.packet }}</span>
                  <span>{{ unlim.expery }}</span>
                </p>
              </td>

              <td :data-label="translate('dashboard.unlimited.packet_tariff_name')" colspan="2">
                {{ traffic.traffic.packet.tariff_name }}
              </td>
              <td :data-label="translate('dashboard.unlimited.traffic_rest')" colspan="2">
                {{ traffic.traffic.packet.traffic_rest }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Unlimited',
  data () {
    return {
      device_unlim_traffic: [],
      summary: [],
      filter_asc: "asc",
      filter_type: "",
    }
  },

  computed:{
    device_unlimited_traffic(){
      let device_unlimited_traffic = [...this.device_unlim_traffic];
      return device_unlimited_traffic.sort(this.compareNumbers);
    },
  },

  created () {
    this.dashboard_unlimited_traffic({})
  },

  watch:{

  },

  methods: {
    async dashboard_unlimited_traffic(){
      await this.$http.v1.dashboardUnlimitedTraffic((response) => {
        this.device_unlim_traffic = response.data.data
        this.summary = response.data.summary
      });
    },
  },
}

</script>

<style scoped lang="scss">
.unlimited_traffic{
  padding: 10px;
  margin-top: 10px;
  height: calc(100% - 10px);
  .response_table{
    padding: 0;
    height: 100%;
    tbody{
      &::-webkit-scrollbar {
        width: 10px;
      }
    }
    th,td{
      &.device{
        background-color: #f3f3f3;
      }
      &.unlim{
        background-color: #f3f3f3;
        p{
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #E3E3E3;
          &:last-child{
            border-bottom: none;
          }
          span{
            display: inline-block;
            flex: 2;
            &.slot{
              flex: 1;
            }
            &.packet{
              flex: 3;
            }
          }
        }
      }
      &.packet{
        background-color: #eee;
      }
    }
    tr{
      a,p{
        font-size: 12px;
        margin: 0;
      }
      a{
        span{
          font-size: 18px;
        }
      }
      .status__wrap{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .problem_device {
          font-size: 22px;
          line-height: 100%;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.online{
            color: #15ab00;
          }
          &.blocked{
            color: #ff4040;
          }
        }
      }
    }
  }
}

</style>
